import React, { useContext } from 'react';
import { IFrame as Iframe, TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import config from '../../../configs/config';
import SyncUpProductContext from '../../../context/SyncUpProductContext';

const {
  iframeTestDashboardMetricsWatchURL,
  iframeTestDashboardMetricsTrackerURL,
  iframeTestDashboardMetricsDriveURL
} = config.powerBiSettings;

function TestDashboardReport() {
  const syncUpProductContext = useContext(SyncUpProductContext);
  const iframe = () => {
    switch (syncUpProductContext.syncUpAppName) {
      case 'TRACKER':
        return iframeTestDashboardMetricsTrackerURL;
      case 'KIDSWATCH':
        return iframeTestDashboardMetricsWatchURL;
      case 'DRIVE':
        return iframeTestDashboardMetricsDriveURL;
      default:
        return;
    }
  };

  return (
    <TmoCard>
      <Iframe src={iframe()} width="100%" height="836px" />
    </TmoCard>
  );
}

export default TestDashboardReport;
